// extracted by mini-css-extract-plugin
export default {"container-spinner":"styles_container-spinner__A+01O"};